export default "__VITE_PUBLIC_ASSET__38b35a93__"